<h1  mat-dialog-title *ngIf="action_type==='create'">Crear Categoría</h1>
<h1  mat-dialog-title *ngIf="action_type==='edit'">Editar Categoría</h1>
<mat-dialog-content  class="create-category">
    <mat-form-field>
        <input matInput  [disabled]="false" placeholder="Nombre de la categoría" required [(ngModel)]="name">
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
    <button  mat-raised-button *ngIf="action_type==='create'" (click)="createCategory()">Crear</button>
    <button  mat-raised-button *ngIf="action_type==='edit'" (click)="editCategory()">Editar</button>
    <!-- <button  mat-raised-button *ngIf="action_type==='edit'" (click)="deleteCategory()">Eliminar</button> -->
    <button  mat-raised-button (click)="closeMe()">Cancelar</button>
</mat-dialog-actions>


